/**
 * 请求库的配置
 * @file 底层请求库封装
 * @author author-name(lhb 1301465186@qq.com)
 */

import axios from 'axios'
import { interceptors } from '@/http/interceptors'

// 开发环境配置
var baseURL = ''
baseURL = "https://xrk-api.paiaipao.cn/"

// 初始化
const service = axios.create({
  baseURL,
  timeout: 30000
})

// 拦截器
interceptors(service)

export default service


